import { type JSX } from 'react';

import { Link } from 'Components/Buttons/Buttons';
import { ColumnConfig, ColumnType } from 'Components/Table/Columns';
import { Table } from 'Components/Table/Table';
import { Text } from 'Components/Text/Text';
import { FRAMEWORKS, GROUPS, OPERATIONAL_CONTROLS } from 'Config/Paths';
import { controlGroupComparator } from 'Helpers/Compare';
import { getHumanReadableControlIdFromControlId } from 'Helpers/ControlFormatter/ControlFormatter';
import { ellipt } from 'Helpers/StringUtils';
import { ControlGroupResponse } from 'Models/OperationalControls';

export interface ControlGroupListViewProps {
    controlGroups: ControlGroupResponse[];
}

export const ControlGroupListView = (props: ControlGroupListViewProps): JSX.Element => {
    const columns: ColumnConfig<ControlGroupResponse>[] = [
        {
            type: ColumnType.CUSTOM,
            name: 'Control Group',
            getValue: (group) => group,
            getTableCellContent: (group) => (
                <>
                    <Link size="sm" to={`/${OPERATIONAL_CONTROLS}/${FRAMEWORKS}/${group.control_framework}/${GROUPS}/${group.control_group_id}`}>
                        {getHumanReadableControlIdFromControlId(`${group.control_framework}#${group.control_group_id}`, group.control_group_name)}
                    </Link>
                    {group.control_group_description && (
                        <Text noStyles variant="Text4">
                            {ellipt(group.control_group_description, 250)}
                        </Text>
                    )}
                </>
            ),
            sortComparator: controlGroupComparator,
        },
        {
            type: ColumnType.STRING,
            name: 'Framework',
            getString: (group) => group.control_framework,
        },
        {
            type: ColumnType.CONTROL_EFFECTIVENESS,
            name: 'Effectiveness',
            getControlEffectiveness: (group) => group.control_group_effectiveness,
        },
    ];

    return <Table<ControlGroupResponse> columns={columns} defaultSortColumn="Control Group" filters={[]} getUniqueIdForRow={(group) => `${group.control_framework}#${group.control_group_id}`} rowsData={props.controlGroups} />;
};
